import { render, staticRenderFns } from "./TheWrapper.vue?vue&type=template&id=fae7fcfe&"
import script from "./TheWrapper.vue?vue&type=script&lang=js&"
export * from "./TheWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports